import React, { useState } from 'react';
import './App.css';
import KeplrConnect from './KeplrConnect';
import logo from './logo.png'; 

function App() {
  const [isConnected, setIsConnected] = useState(false);
  const [walletAddress, setWalletAddress] = useState('');

  const handleConnect = (address) => {
    setIsConnected(true);
    setWalletAddress(address);
  };
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="Cosmos News Logo" />
        <p className="enjoying-content">Enjoying the content?</p>
        <p className="enjoying-content">Meet Tippy. The tip app. </p>
        <h1>Send a Tip in Juno</h1>
        <KeplrConnect onConnect={handleConnect} />
      </header>
    </div>
  );
}

export default App;